<div class="box flex">
    <h1>
        <span style="color: black;">Platform</span>
        <span style="color: #0093a1;">Portal</span>
    </h1>
</div>